import MuiTimeline, { TimelineProps as MuiProps } from '@material-ui/lab/Timeline';
import React, { FunctionComponent } from 'react';

export interface TimelineProps extends MuiProps {
    /**
     * The content of the component.
     */
    children?: React.ReactNode;
    /**
     * The position where the timeline's content should appear.
     */
    align?: 'left' | 'right' | 'alternate';
}

const Timeline: FunctionComponent<TimelineProps> = (props: TimelineProps) => <MuiTimeline {...props} />;

export default Timeline;
